import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface IssueDescriptionProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  minLength?: number;
  showCharacterCount?: boolean;
}

const IssueDescription = ({
  value,
  onChange,
  error,
  label = 'Detailed Description *',
  placeholder = 'Please provide a detailed description of your issue. Include any relevant information such as error messages, steps to reproduce the issue, and what you expected to happen.',
  rows = 6,
  maxLength = 500,
  minLength = 20,
  showCharacterCount = true,
}: IssueDescriptionProps) => {
  const isApproachingLimit = value.length > maxLength - 50;
  const isOverLimit = value.length > maxLength;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Issue Description</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="description">{label}</Label>
          <Textarea
            id="description"
            placeholder={placeholder}
            value={value}
            onChange={e => onChange(e.target.value)}
            rows={rows}
            maxLength={maxLength}
            className={error ? 'border-red-500' : ''}
          />
          {error && <p className="text-sm text-red-500">{error}</p>}
          {showCharacterCount && (
            <div className="flex justify-between items-center text-sm text-gray-500">
              <span>
                {value.length}/{maxLength} characters (minimum {minLength}{' '}
                required)
              </span>
              {isApproachingLimit && !isOverLimit && (
                <span className="text-orange-500">Approaching limit</span>
              )}
              {isOverLimit && (
                <span className="text-red-500">Character limit exceeded</span>
              )}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default IssueDescription;
